import { DeclineReason } from './types';

export const declineReasons = [
    {
        value: DeclineReason.DECLINE_REASON_BROKEN_REQUISITES,
        label: 'Битые реквизиты',
    },
    {
        value: DeclineReason.DECLINE_REASON_UNSPECIFIED,
        label: 'Другое',
    },
];
